export const createSimpleAction = (type, fieldName) => (value) => ({type, payload: {[fieldName]: value}})
export const createTypeAction = (type) => () => ({type})
